export const BUTTON_TYPES = {
  FILLED: 'filled',
  OUTLINE: 'outline',
  TEXT: 'text',
  ICON: 'icon',
  ICON_FILLED: 'iconFilled',
  ICON_OUTLINE: 'iconOutline',
  RAW: 'raw',
} as const;

export const BUTTON_SHAPES = {
  DEFAULT: 'default',
  ROUND: 'round',
} as const;

export const BUTTON_SIZES = {
  S: 's',
  C: 'c',
  M: 'm',
  L: 'l',
} as const;

export const sizes = {
  s: '1.538rem',
  c: '1.846rem',
  m: '2.154rem',
  l: '3.077rem',
} as const;

export const mobileSizes = {
  s: '1.249625rem',
  c: '1.5rem',
  m: '1.750125rem',
  l: '2.5rem',
} as const;

export const ButtonTypesValuesArray = Object.values(BUTTON_TYPES);
export const ButtonSizesValuesArray = Object.values(BUTTON_SIZES);
export const ButtonShapesValuesArray = Object.values(BUTTON_SHAPES);
export const ButtonInteractionStates = ['hover', 'focus', 'active'];

export const ButtonTypesValuesString = JSON.stringify(ButtonTypesValuesArray);
export const ButtonSizesValuesString = JSON.stringify(ButtonSizesValuesArray);
export const ButtonShapesValuesString = JSON.stringify(ButtonShapesValuesArray);
export const ButtonInteractionStatesValuesString = JSON.stringify(ButtonInteractionStates);
